import Vaibhav_Sawant from "../../../images/coordinators/Vaibhav_Sawant.jpg";
import Chirag_Singhal from "../../../images/coordinators/Chirag_Singhal.jpg";
import Ishan_Nayak from "../../../images/coordinators/Ishan_Nayak.jpg";
import Arpit_Pandey from "../../../images/coordinators/Arpit_Pandey.jpg";
import Anushree_Banerjee from "../../../images/coordinators/Anushree_Banerjee.jpg";
import Aparna_Gupta from "../../../images/coordinators/Aparna_Gupta.jpg";
import Kushal_Jain from "../../../images/coordinators/Kushal_Jain.jpg";
import Pratham_Gandhi from "../../../images/coordinators/Pratham_Gandhi.jpg";
import Shreya_Borikar from "../../../images/coordinators/Shreya_Borikar.jpg";
import Satyam_Singh from "../../../images/coordinators/Satyam_Singh.jpg";
import Pramil_Kesarwani from "../../../images/coordinators/Pramil_Kesarwani.jpg";
import Arkita_Dam from "../../../images/coordinators/Arkita_Dam.jpg";
import Sameer_Trivedi from "../../../images/coordinators/Sameer_Trivedi.jpg";
import Sujoy_Banerjee from "../../../images/coordinators/Sujoy_Banerjee.jpg";
import Gopal_Katankar from "../../../images/coordinators/Gopal_Katankar.jpg";
import Suraj_Jogani from "../../../images/coordinators/Suraj_Jogani.jpg";
import Nakshatra_Singh from "../../../images/coordinators/Nakshatra_Singh.jpg";
import Pranshul_Hatwar from "../../../images/coordinators/Pranshul_Hatwar.jpg";
import Abhijeet_Kumar_Singh from "../../../images/coordinators/Abhijeet_Kumar_Singh.jpg";
import Rishav_Gandhi from "../../../images/coordinators/Rishav_Gandhi.jpg";

export const coordinatorsList = [
  {
    id: 1,
    name: "Vaibhav Sawant",
    imgUrl: Vaibhav_Sawant,
    linkedinUrl: "https://www.linkedin.com/in/vaibhav-sawant-59522922a/",
    instaUrl: "https://instagram.com/simply_vaibhav?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain: "Chemical"
    
  },
  {
    id: 2,
    name: "Chirag Singhal",
    imgUrl: Chirag_Singhal,
    linkedinUrl: "https://www.linkedin.com/in/chirag-singhal-a61b40228/",
    instaUrl: "https://instagram.com/1502.chirag?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"CSE"

  },
  {
    id: 3,
    name: "Ishan Nayak",
    imgUrl: Ishan_Nayak,
    linkedinUrl: "https://www.linkedin.com/in/ishan-nayak-340b6b218/",
    instaUrl: "https://instagram.com/ishan_nayak_1607?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 4,
    name: "Arpit Pandey",
    imgUrl: Arpit_Pandey,
    linkedinUrl: "https://www.linkedin.com/in/arpit-pandey-1866a2142/",
    instaUrl: "https://www.instagram.com/arpitp_192/?hl=en",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"MME"
  },
  {
    id: 5,
    name: "Anushree Banerjee",
    imgUrl: Anushree_Banerjee,
    linkedinUrl: "https://www.linkedin.com/in/anushree001/",
    instaUrl: "http://instagram.com/momo_02.04/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"Bio-Med"
  },
  {
    id: 6,
    name: "Aparna Gupta",
    imgUrl: Aparna_Gupta,
    linkedinUrl: "https://www.linkedin.com/in/aparna-gupta-185981214/",
    instaUrl: "https://instagram.com/apar_na_gupta__?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"Chemical"
  },
  {
    id: 7,
    name: "Kushal Jain",
    imgUrl: Kushal_Jain,
    linkedinUrl: "https://www.linkedin.com/in/kushal-jain-8645ab202/",
    instaUrl: "https://www.instagram.com/kushaljain.202/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"Chemical"
  },
  {
    id: 8,
    name: "Pratham Gandhi",
    imgUrl: Pratham_Gandhi,
    linkedinUrl: "https://www.linkedin.com/in/prathamgandhi1308/",
    instaUrl: "#",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"CSE"
  },
  {
    id: 9,
    name: "Shreya Borikar",
    imgUrl: Shreya_Borikar,
    linkedinUrl: "https://www.linkedin.com/in/shreya-borikar-223b75227/",
    instaUrl: "https://instagram.com/shreya1211_?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"CSE"
  },
  {
    id: 10,
    name: "Satyam Singh",
    imgUrl: Satyam_Singh,
    linkedinUrl: "https://www.linkedin.com/in/satyam-singh-0a0b4721a/",
    instaUrl: "https://www.instagram.com/singhsatyam480532023/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"CSE"
  },
  {
    id: 11,
    name: "Pramil Kesarwani",
    imgUrl: Pramil_Kesarwani,
    linkedinUrl: "https://www.linkedin.com/in/pramil-kesarwani-10b374214/",
    instaUrl: "https://www.instagram.com/kesarwanipramil/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 12,
    name: "Arkita Dam",
    imgUrl: Arkita_Dam,
    linkedinUrl: "https://www.linkedin.com/in/arkita-dam-7865551a1/",
    instaUrl: "https://instagram.com/shreya1211_?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 13,
    name: "Sameer Trivedi",
    imgUrl: Sameer_Trivedi,
    linkedinUrl: "https://www.linkedin.com/in/sameert89/",
    instaUrl: "https://www.instagram.com/s_ameer___/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 14,
    name: "Sujoy Banerjee",
    imgUrl: Sujoy_Banerjee,
    linkedinUrl: "https://www.linkedin.com/in/sujoy-banerjee-a698aa210/",
    instaUrl: "https://instagram.com/sujoy0910?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 15,
    name: "Gopal Katankar",
    imgUrl: Gopal_Katankar,
    linkedinUrl: "https://www.linkedin.com/in/gopal-katankar-a03849206/",
    instaUrl: "https://www.instagram.com/gopalkatankar/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"ECE"
  },
  {
    id: 16,
    name: "Suraj Jogani",
    imgUrl: Suraj_Jogani,
    linkedinUrl: "https://www.linkedin.com/in/suraj-jogani/",
    instaUrl: "https://instagram.com/_jogani.suraj_?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"Electrical"
  },
  {
    id: 17,
    name: "Nakshatra Singh",
    imgUrl: Nakshatra_Singh,
    linkedinUrl: "https://www.linkedin.com/in/nakshatra-singh-96929a21b/",
    instaUrl: "https://instagram.com/nakshsinghhh?igshid=OGQ5ZDc2ODk2ZA==",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"IT"
  },
  {
    id: 18,
    name: "Pranshul Hatwar",
    imgUrl: Pranshul_Hatwar,
    linkedinUrl: "https://www.linkedin.com/in/pranshul-hatwar/",
    instaUrl: "https://www.instagram.com/pranshul_hatwar1510/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"IT"
  },
  {
    id: 19,
    name: "Abhijeet Kumar Singh",
    imgUrl: Abhijeet_Kumar_Singh,
    linkedinUrl: "https://www.linkedin.com/in/abhijeet-kumar-singh-3517b7122/",
    instaUrl: "https://www.instagram.com/abhijeetsingh12082001/",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"MME"
  },
  {
    id: 20,
    name: "Rishav Gandhi",
    imgUrl: Rishav_Gandhi,
    linkedinUrl: "https://www.linkedin.com/in/rishav-gandhi-998a74211/",
    instaUrl: "https://instagram.com/___rishav._?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D",
    facebookUrl : "#",
    githubUrl : "#",
    domain:"MME"
  }
];
